<template>
    <div
      class="menu-icon-wrapper"
      @click="toggleDropdownDisplay"
    >
        <img :src="imgSource" alt="icon" class="icon-img">
        <div v-text="iconLabel" class="icon-label" v-if="displayLabel" />
    </div>
</template>

<script>
import VueTypes from "vue-types";

export default {
    props: {
        imgSource: VueTypes.string.isRequired,
        iconLabel: VueTypes.string.isRequired,
        displayLabel: VueTypes.bool.isRequired,
        dropdown: VueTypes.bool.def(false),
    },
    methods: {
        toggleDropdownDisplay() {
            if (this.dropdown) {
                this.$emit('toggleDropdownDisplay')
            }
        }
    }
}
</script>

<style scoped>
  .menu-icon-wrapper {
      display: flex;
  }
  .icon-img {
      height: 30px;
      width: 30px;
      /*margin-right: 10px;*/
  }
  .icon-label {
      line-height: 30px;
      color: #ffffff;
      font-weight: bold;
      font-size: 14px;
  }
</style>
